const styles = (theme) => ({
  preloaderContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 'var(--preloader-padding-top, 70px)', // header
    backgroundColor: "white"
  },
  loadingIndicator: {
    color: theme.palette.primary.main
  }
});

export default styles;

